<template>
    <div class="container">
        <div class="content-box">
          <div class="element-wrapper pb-0">
            <div class="element-actions">
              <a v-if="!profissional" class="btn btn-warning" @click="novo()">
                <i class="fa fa-file"></i> <span>Novo</span>
              </a>
              <router-link class="btn btn-primary" :to="{name: 'PageCadastroProfissionalList'}">
                <i class="fa fa-reply"></i> <span>Voltar</span>
              </router-link>
            </div>
            <h3 class="element-header">
              Profissionais
            </h3>
          </div>
          <transition>
            <router-view></router-view>
          </transition>
        </div>
      
    </div>
</template>
<script>
export default {
  computed: {
    profissional () {
      return this.$store.getters.corpoClinico
    },
    showBtnVoltar () {
      return this.$router.to === 'PageCadastroProfissionalForm'
    }
  },
  methods: {
    novo () {
      this.$store.dispatch('setCorpoClinico').then(() => {
        this.$router.push({ name: 'PageCadastroProfissionalForm' })
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/dashboard/CadastroProfissional.vue